export const EPSILON = 0.000000001

